import { connect } from 'react-redux';
import { fetchEmergencyStatusByStationById } from '../../actions/emergency-history';
import StationStatusHistory from './StationStatusHistory';

function mapStateToProps({ emergencyStatusHistory }, ownProps) {
  const { stationId } = ownProps;
  const { error, byStationId, isFetchingEmergencyStatus } = emergencyStatusHistory;

  return {
    isFetchingEmergencyStatus,
    error: !!error,
    emergencyStatusHistory: byStationId[stationId],
  };
}

function mapDispatchToProps(dispatch) {
  return ({
    fetchEmergencyStatusByStation: stationId => dispatch(fetchEmergencyStatusByStationById(stationId)),
  });
}

export default connect(mapStateToProps, mapDispatchToProps)(StationStatusHistory);
